/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEnergySlash: {
  name: 'energy-slash';
  data: string;
} = {
  name: 'energy-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.97 1.757a1 1 0 0 0-1.802-.312l-2.667 4a1 1 0 0 0 1.664 1.11l1.413-2.12 1.452 5.808A1 1 0 0 0 15 11h2.131l-.963 1.445a1 1 0 0 0 1.664 1.11l2-3A1 1 0 0 0 19 9h-3.22l-1.81-7.243Zm-6.138 9.798a1 1 0 0 0-1.664-1.11l-2 3A1 1 0 0 0 5 15h3.22l1.81 7.242a1 1 0 0 0 1.802.313l3-4.5a1 1 0 0 0-1.664-1.11l-1.746 2.62-1.452-5.808A1 1 0 0 0 9 13H6.869l.963-1.445ZM4.707 3.293a1 1 0 1 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16Z" fill="currentColor"/></svg>`,
};
